import { createAsyncThunk } from '@reduxjs/toolkit'
import DataService from "../service";
import { constant } from '../constant'
const { path } = constant;

export const availableBedsList = createAsyncThunk(
    'bed/availableBedsList',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+`client/ward/v1/available-beds/${arg?.wardId}`, rejectWithValue)
)
export const reservedBedsList = createAsyncThunk(
    'bed/reservedBedsList',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+`client/ward/v1/reserved-beds/${arg?.wardId}`, rejectWithValue)
)
export const occupiedBedsList = createAsyncThunk(
    'bed/occupiedBedsList',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+`client/ward/v1/occupied-beds/${arg?.wardId}`, rejectWithValue)
)

export const occupiedAuditTrailBedsList = createAsyncThunk(
    'bed/occupiedAuditTrailBedsList',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+`/client/ward/v1/single-bed-audit/${arg?.bedId}`, rejectWithValue)
)

export const occupyBed = createAsyncThunk(
    'bed/occupyBed',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/ward/v1/occupy-bed', rejectWithValue)
)

export const reserveBed = createAsyncThunk(
    'bed/reserveBed',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/ward/v1/reserve-bed', rejectWithValue)
)

export const occupyReserveBed = createAsyncThunk(
    'bed/occupyReserveBed',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/ward/v1/occupy-reserved-bed', rejectWithValue)
)

export const extendEdd = createAsyncThunk(
    'bed/extendEdd',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/ward/v1/extend-edd', rejectWithValue)
)

export const modifyEdd = createAsyncThunk(
    'bed/modifyEdd',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'client/ward/v1/modify-edd', rejectWithValue)
)

export const releaseReservedBed = createAsyncThunk(
    'bed/releaseReserveBed',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/ward/v1/release-reserved-bed/${arg?.wardId}/${arg?.bedId}`, rejectWithValue)
)

export const releaseOccupiedBed = createAsyncThunk(
    'bed/releaseOccupiedBed',
    (arg, { rejectWithValue }) => DataService.get(arg, path+`client/ward/v1/release-occupied-bed/${arg?.wardId}/${arg?.bedId}`, rejectWithValue)
)

